import { apiClient } from "@/http";
import { apiRoutes } from "./apiRoutes";
import type { PageQuery, PageResp } from "./page";

// 데이터셋 메모(댓글)다. 멤버가 공용 Dataset 에 남기는 짧은 코멘트다.
// 메모는 작성 날짜, 담당자, 내용만 가진다. 대댓글과 편집은 없다.
// 타입은 backend service/memo/schema.py 와 1:1 로 대응한다.

export type Memo = {
  uuid: string;
  // 작성자 member uuid(식별). 표시 이름은 author_name 스냅샷을 쓴다.
  author_member_uuid: string;
  // 작성 시점의 표시 이름 스냅샷이다. 멤버가 이름을 바꿔도 작성 당시 이름을 보존한다.
  author_name: string;
  content: string;
  created_at: string;
  // 서버가 계산한 삭제 권한이다(본인 OR admin 모더레이션). 값은 보는 사람마다 다르다.
  // FE 는 이 값만 보고 삭제 버튼을 표시한다. FE 는 admin 규칙을 클라이언트에서 재현하지 않는다.
  can_delete: boolean;
};

// 목록 행 요약이다(카드의 최근 메모, 표의 인디케이터용). 서버는 이 값을 Dataset 응답에
// optional 로 포함한다.
export type MemoPreview = {
  author_name: string;
  content: string;
  created_at: string;
};

export type MemoCreateReq = {
  content: string;
};

export type MemoListQuery = PageQuery;

// GET: 메모 목록(최신순). read 권한이 있으면 누구나 조회한다. 상세를 볼 수 있으면 read 권한이 있다.
export async function listMemos(
  datasetUuid: string,
  query: MemoListQuery = {},
): Promise<PageResp<Memo>> {
  const response = await apiClient.get<PageResp<Memo>>(apiRoutes.dataset.memos(datasetUuid), {
    params: query,
  });
  return response.data;
}

// POST: 메모 작성(member+). 서버는 생성한 메모를 그대로 반환한다(author_name·can_delete 포함).
export async function createMemo(datasetUuid: string, payload: MemoCreateReq): Promise<Memo> {
  const response = await apiClient.post<Memo>(apiRoutes.dataset.memos(datasetUuid), payload);
  return response.data;
}

// DELETE: 단건 삭제. 서버는 본인과 admin 만 허용한다. 그 외 요청자는 403 을 받는다.
export async function deleteMemo(datasetUuid: string, memoUuid: string): Promise<void> {
  await apiClient.delete(apiRoutes.dataset.memoDetail(datasetUuid, memoUuid));
}
